import { configureStore } from "@reduxjs/toolkit";
import inboxRefreshMiddleware from "./inboxRefreshMiddleware";
import authReducer from "../slices/auth/authSlice";
import businesInfoReducer from "../slices/businessinfosetup/businessInfoSlice";
import workflowReducer from "../slices/workflowSlice/workflowSlice"
import budgetReducer from "../slices/budgetSlice/budgetSlice";
import budgetReportReducer from "../slices/budgetSlice/budgetReportSlice";
import accruedInterestReducer from "../slices/financialReportSlice/accruedInterestSlice"; 
import bankStatementReducer from "../slices/bankSlice/bankStatementSlice";
import clientPOReportReducer from "../slices/clientPOSlice/clientPOReportSlice";
import transactionLogReducer from "../slices/financialReportSlice/transactionLogSlice";
import termLoanReportReducer from "../slices/termLoanSlice/termLoanReportSlice";
import assetDepreciationReportReducer from "../slices/assetsSlice/assetDepreciationReportSlice";
import assetsalesreportReducer from "../slices/assetsSlice/assetSalesReportSlice";
import viewCurrentStockReducer from "../slices/stockSlice/viewCurrentStockSlice";
import supplierPOStatusReducer from "../slices/stockSlice/supplierPOStatusSlice";
import scrapWalletReportReducer from "../slices/stockSlice/scrapWalletReportSlice";
import gstReportReducer from "../slices/gstSlice/gstReportSlice";
import supplierReportReducer from "../slices/supplierPOSlice/supplierReportSlice";  
import spPOReportReducer from "../slices/spPOSlice/spPOReportSlice"; 
import companyOverallStatus from "../slices/financialReportSlice/companyOverallStatusSlice";
import accountStatus from "../slices/financialReportSlice/accountStatusSlice";
import stockReconciliationReducer from "../slices/stockSlice/stockReconciliationSlice";
import stockTransferReportReducer from "../slices/stockSlice/stockTransferReportSlice";
import closingStockReportReducer from "../slices/stockSlice/closingStockReportSlice";
import viewIndentsReportReducer from "../slices/stockSlice/viewIndentReportSlice";
import dailyIssuedItemsReportReducer from "../slices/stockSlice/dailyIssueItemsReportSlice";
import itemCodeReportReducer from "../slices/stockSlice/ItemCodeReportSlice";
import lostScrapReportReducer from "../slices/stockSlice/lostScrapReportSlice";
import lcbgReducer from "../slices/lcbgSlice/lcbgSlice";
import stockSummaryReducer from "../slices/financialReportSlice/stockSummarySlice";
import unsecuredLoanReportReducer from "../slices/termLoanSlice/unsecuredLoanReportSlice";
import cmsPaymentReportSlice from "../slices/HrReportSlice/cmsPaymentReportSlice";
import labourCMSPaymentReportReducer from "../slices/HrReportSlice/labourCMSPaymentReportSlice";
import inboxNotificationReducer from "../slices/notificationSlice/userInboxNotificationSlice";

import approvalReducer from "../slices/CommonSlice/getStatusSlice";
import VendorPaymentReducer from "../slices/VendorPaymentSlice/vendorPaymentSlice"
import SuppplierInvoiceReducer from "../slices/vendorInvoiceSlice/supplierInvoiceSlice";
import SupplierPOReducer from "../slices/supplierPOSlice/supplierPOSlice";
import purchaseHelperReducer from "../slices/supplierPOSlice/purcahseHelperSlice";
import supplierPOCreationReducer from "../slices/supplierPOSlice/supplierPOCreationSlice";
import supplierPOAmendCreationReducer from "../slices/supplierPOSlice/supplierPOAmendCreationSlice";
import SppoReducer from "../slices/spPOSlice/spPoSlice"
import costCenterSlice from "../slices/costCenterSlice/costCenterAppprovalSlice";
import generalInvoiceSlice from "../slices/generalInvoiceSlice/genralInvoiceSlice";
import roleReducer from "../slices/userRolesSlice/userRolesSlice";
import empRoleAssignment from "../slices/userRolesSlice/userRoleAssignSlice";
import ccBudgetAmendment from "../slices/budgetSlice/ccBudgetAmendmentSlice";
import dcaBudgetAmendment from "../slices/budgetSlice/dcaBudgetAmendmentSlice";
import staffAttendanceReportReducer from "../slices/HrReportSlice/staffAttendanceReportSlice";
import employeeExitReportReducer from "../slices/HrReportSlice/employeeExitReportSlice";
import leaveReportSlice from "../slices/HrReportSlice/leaveReportSlice";
import costCenterCreationReducer from "../slices/costCenterSlice/costCenterCreationSlice";
import clientPOVerificationReducer from "../slices/clientPOSlice/clientPOVerificationSlice";
import lostDamagedItemsVerificationReducer from "../slices/stockSlice/lostDamagedItemsVerificationSlice";
import transferRecieptOthersVerificationReducer from "../slices/purchaseSlice/transferRecieptOthersVerificationSlice";
import verifyNewStockReceivedReducer from "../slices/purchaseSlice/verifyNewStockReceivedSlice";
import verifyVendorReducer from "../slices/purchaseSlice/verifyVendorSlice";
import dailyIssuedItemsReducer from "../slices/stockSlice/dailyIssueSlice";
import scrapSaleReducer from "../slices/stockSlice/scrapSalesVerificationSlice";
import closeSPPOReducer from "../slices/spPOSlice/closeSPPOSlice";
import sppoAmend from "../slices/spPOSlice/sppoAmendSlice";
import sppoAmendCreation from "../slices/spPOSlice/sppoAmendCreationSlice";
import sppoCloseCreation from "../slices/spPOSlice/sppoCloseCreationSlice";
import sppoCreation from "../slices/spPOSlice/sppoCreationSlice";
import supplierPOAmendVerificationReducer from "../slices/supplierPOSlice/supplierPOAmendVerificationSlice";
import monthlyattendance from "../slices/HRSlice/monthlyAttendanceSlice";
import staffdailyattendance from "../slices/HRSlice/staffDailyAttendanceSlice";
import labourobjectivesgoals from "../slices/HRSlice/labourObjectivesGoalsSlice";
import staffobjectivesgoals from "../slices/HRSlice/staffObjectivesandGoalsSlice";
import employeectc from "../slices/HRSlice/employeeCTCSlice";
import labourctc from "../slices/HRSlice/labourCTCSlice";
import labourpayrevision from "../slices/HRSlice/labourPayRevisionSlice";
import staffpayrevision from "../slices/HRSlice/staffPayRevisionSlice";
import employeeleave from "../slices/HRSlice/employeeLeaveSlice";
import dividendDeclaration from "../slices/capitalSlice/dividendDeclarationSlice";
import dividendDistribution from "../slices/capitalSlice/dividendDistributionSlice";
import dividendBankPayment from "../slices/capitalSlice/dividendBankPaymentSlice";
import bankDetails from "../slices/CommonSlice/bankDetailsSlice";
import chequeNumbers from "../slices/bankSlice/chequeNumbersSlice";
import pfesireport from "../slices/HrReportSlice/pfandesiReportSlice";
import salaryreport from "../slices/HrReportSlice/salaryReportSlice";
import staffreport from "../slices/HrReportSlice/staffReportSlice";
import staffctcreport from "../slices/HrReportSlice/staffCTCReportSlice";
import staffcmspay from "../slices/HRSlice/staffCMSPayCreationSlice";
import hrStaffSepPayment from "../slices/HRSlice/hrStaffSepPaymentSlice";
import labourSepPayment from "../slices/HRSlice/labourSepPaymentSlice";
import staffcmspayverification from "../slices/HRSlice/staffCMSPayVerificationSlice";
import staffpayroll from "../slices/HRSlice/staffPayrollGenerationSlice";
import staffpayrollverification from "../slices/HRSlice/staffPayrollVerificationSlice";
import salaryDeductionArrear from "../slices/HRSlice/staffSalaryDeductionArrearSlice";
import salaryDeductionArearVerification from "../slices/HRSlice/salaryDeductionArearVerificationSlice";
import staffJoin from "../slices/HRSlice/staffJoinSlice";
import staffVerify from "../slices/HRSlice/staffRegistrationVerifySlice";
import employeeTransfer from "../slices/HRSlice/employeeTransferSlice";
import employeeExitReducer from "../slices/HRSlice/employeeExitSlice";
import staffFullFinalReducer from "../slices/HRSlice/staffFullFinalSlice";
import staffAdvanceReducer from "../slices/HRSlice/staffAdvanceSlice";
import staffAppraisalReducer from "../slices/HRSlice/staffAppraisalSlice";
import staffCTCCreationReducer from "../slices/HRSlice/staffCTCCreationSlice";
import staffAttendanceEntryReducer from "../slices/HRSlice/staffAttendanceEntrySlice";
import staffReportingConfigReducer from "../slices/HRSlice/staffReportingConfigSlice";
import employeePortalReducer from "../slices/HRSlice/employeePortalSlice";
import cashVoucherReducer from "../slices/accountsSlice/cashVoucherSlice";
import vendorCashPaymentReducer from "../slices/accountsSlice/vendorCashPaymentSlice";
import ccCashTransferReducer from "../slices/accountsSlice/ccCashTransferSlice";
import ccClosingReducer from "../slices/accountsSlice/ccClosingSlice";
import clientInvoiceReducer from "../slices/accountsSlice/clientInvoiceSlice";
import clientManfInvoiceReducer from "../slices/accountsSlice/clientManufacturingInvoiceSlice";
import clientScrapInvoiceReducer from "../slices/accountsSlice/clientScrapSaleInvoiceSlice";
import clientTradingInvoiceReducer from "../slices/accountsSlice/clientTradingInvoiceSlice";
import genInvoiceCreationReducer from "../slices/accountsSlice/generalInvoiceCreationSlice";
import miscInvoiceCreationReducer from "../slices/accountsSlice/miscInvoiceCreationSlice";
import miscInvoiceVerificationReducer from "../slices/accountsSlice/miscInvoiceVerificationSlice";
import miscPaymentReducer from "../slices/accountsSlice/miscPaymentSlice";
import miscPaymentVerificationReducer from "../slices/accountsSlice/miscPaymentVerificationSlice";
import bankWithdrawalReducer from "../slices/accountsSlice/bankWithdrawalSlice";
import bankTransferReducer from "../slices/accountsSlice/bankTransferSlice";
import genInvPaymentReducer from "../slices/accountsSlice/generalInvoicePaymentSlice";
import ccSepPaymentReducer from "../slices/accountsSlice/ccSepPaymentSlice";
import clientPOCreationReducer from "../slices/accountsSlice/clientPOCreationSlice";
import clientPOAmendReducer from "../slices/accountsSlice/clientPOAmendSlice";
import workInProgressReducer from "../slices/accountsSlice/workInProgressSlice";
import sppoInvoiceReducer from "../slices/spPOSlice/sppoInvoiceSlice";
import supplierPOInvoiceReducer from "../slices/supplierPOSlice/supplierPOInvoiceSlice";
import loadWalletReducer from "../slices/accountsSlice/loadWalletSlice";
import lcbgCreationReducer from "../slices/accountsSlice/lcbgCreationSlice";
import sppoPaymentReducer from "../slices/purchaseSlice/sppoPaymentSlice";
import vendorCMSPaymentReducer from "../slices/purchaseSlice/vendorCMSPaymentSlice";
import vendorTDSPaymentReducer from "../slices/purchaseSlice/vendorTDSPaymentSlice";
import boeSettlementReducer from "../slices/purchaseSlice/boeSettlementSlice";
import itemDepreciationConfigReducer from "../slices/purchaseSlice/itemDepreciationConfigSlice";
import hsnCreationReducer from "../slices/purchaseSlice/hsnCreationSlice";
import itemCodeUpdationReducer from "../slices/purchaseSlice/itemCodeUpdationSlice";
import indentAmendReducer from "../slices/purchaseSlice/indentAmendSlice";
import assetSaleReducer from "../slices/purchaseSlice/assetSaleSlice";
import assetSaleReceiptReducer from "../slices/purchaseSlice/assetSaleReceiptSlice";
import ccStockCloseReducer from "../slices/purchaseSlice/ccStockCloseSlice";
import vendorCreationReducer from "../slices/purchaseSlice/vendorCreationSlice";
import hrRulesReducer from "../slices/HRSlice/hrRulesSlice";
import basicBusinessInfoReducer from "../slices/ReportsSlice/basicBusinessInfoSlice";
import consolidateCashflowReportReducer from "../slices/ReportsSlice/consolidateCashflowReportSlice";
import itDepreciationReportReducer from "../slices/ReportsSlice/itDepreciationReportSlice";
import projectFinancialStatusSummaryReducer from "../slices/ReportsSlice/projectFinancialStatusSummarySlice";
import stockStatusReportReducer from "../slices/ReportsSlice/stockStatusReportSlice";
import vendorInvoiceReportReducer from "../slices/ReportsSlice/vendorInvoiceReportSlice";
import vendorBalanceReportReducer from "../slices/ReportsSlice/vendorBalanceReportSlice";
import vendorOutStandingReportReducer from "../slices/ReportsSlice/vendorOutStandingReportSlice";
import clientOutstandingReportReducer from "../slices/ReportsSlice/clientOutstandingReportSlice";
import clientPaymentsReportReducer from "../slices/ReportsSlice/clientPaymentsReportSlice";
import clientTDSReportReducer from "../slices/ReportsSlice/clientTDSReportSlice";
import fdReportReducer from "../slices/ReportsSlice/fdReportSlice";
import fdPaymentsReducer from "../slices/accountsSlice/fdPaymentsSlice";
import assignBudgetReducer from "../slices/budgetSlice/assignBudgetSlice";
import clientBadDebtReducer from "../slices/accountsSlice/clientBadDebtSlice";
import clientReceiptReducer from "../slices/accountsSlice/clientReceiptSlice";
import clientRecievableVerificationReducer from "../slices/accountsSlice/clientRecievableVerificationSlice";
import advancePaymentVerificationReducer from "../slices/accountsSlice/advancePaymentVerificationSlice";
import retentionPaymentVerificationReducer from "../slices/accountsSlice/retentionPaymentVerificationSlice";
import holdPaymentVerificationReducer from "../slices/accountsSlice/holdPaymentVerificationSlice";
import scrapSaleReceiptReducer from "../slices/accountsSlice/scrapSaleReceiptSlice";
import scrapSaleReceiptVerificationReducer from "../slices/accountsSlice/scrapSaleReceiptVerificationSlice";
import refundReducer from "../slices/accountsSlice/refundSlice";
import refundVerificationReducer from "../slices/accountsSlice/refundVerificationSlice";
import centralDayBookReducer from "../slices/accountsSlice/centralDayBookSlice";
import centralDayBookVerificationReducer from "../slices/accountsSlice/centralDayBookVerificationSlice";
import journalVoucherReducer from "../slices/accountsSlice/journalVoucherSlice";
import creditDebitNoteReducer from "../slices/purchaseSlice/creditDebitNoteSlice";
import lcbgAmendReducer from "../slices/purchaseSlice/lcbgAmendSlice";
import vendorPayableWriteoffCreationReducer from "../slices/purchaseSlice/vendorPayableWriteoffSlice";
import unsecuredLoanReducer from "../slices/accountsSlice/unsecuredLoanSlice";
import termLoanCreationReducer from "../slices/accountsSlice/termLoanCreationSlice";
import termLoanPaymentReducer from "../slices/accountsSlice/termLoanPaymentSlice";
import agencyCreationReducer from "../slices/accountsSlice/agencyCreationSlice";
import itCodeReducer from "../slices/accountsSlice/itCodeSlice";
import dcaCreationReducer from "../slices/accountsSlice/dcaCreationSlice";
import subDcaReducer from "../slices/accountsSlice/subDcaSlice";
import chequeBookCreationReducer from "../slices/accountsSlice/chequeBookCreationSlice";
import taxRegistrationReducer from "../slices/accountsSlice/taxRegistrationSlice";
import bankAccountReducer from "../slices/accountsSlice/bankAccountSlice";
import clientReducer from "../slices/accountsSlice/clientSlice";
import rejectionAlertReducer from "../slices/rejectionAlertSlice/rejectionAlertSlice";
import labourConfigReducer from "../slices/labourConfigSlice/labourConfigSlice";
import labourPayrollReducer from "../slices/labourPayrollSlice/labourPayrollSlice";
import labourCMSPaymentReducer from "../slices/HRSlice/labourCMSPaymentSlice";
import labourCMSVerificationReducer from "../slices/HRSlice/labourCMSVerificationSlice";
import bulkWorkerRegReducer from "../slices/HRSlice/bulkWorkerRegistrationSlice";
import bulkWorkerVerifyReducer from "../slices/HRSlice/bulkWorkerVerificationSlice";
import generalPaymentReducer from "../slices/accountsSlice/generalPaymentSlice";
import clientPOBudgetLimitConfigReducer from "../slices/accountsSlice/clientPOBudgetLimitConfigSlice";
import companyDepreciationConfigReducer from "../slices/accountsSlice/companyDepreciationConfigSlice";
import ccDayLimitConfigReducer from "../slices/accountsSlice/ccDayLimitConfigSlice";
import pageLevelConfigReducer from "../slices/accountsSlice/pageLevelConfigSlice";
import posUploadDocsLimitConfigReducer from "../slices/accountsSlice/posUploadDocsLimitConfigSlice";
import tdsConfigureReducer from "../slices/accountsSlice/tdsConfigureSlice";
import approvalLimitSettingsReducer from "../slices/accountsSlice/approvalLimitSettingsSlice";
import depreciationConfigReducer from "../slices/accountsSlice/depreciationConfigSlice";
import overheadPercentageConfigReducer from "../slices/accountsSlice/overheadPercentageConfigSlice";
import accruedInterestConfigReducer from "../slices/accountsSlice/accruedInterestConfigSlice";
import budgetViewAttachmentConfigReducer from "../slices/accountsSlice/budgetViewAttachmentConfigSlice";
import labourReportReducer from "../slices/HrReportSlice/labourReportSlice";
import labourBankChangeReducer from "../slices/HRSlice/labourBankChangeSlice";
import empBankChangeReducer from "../slices/HRSlice/empBankChangeSlice";
import itemCodeVerificationReducer from "../slices/purchaseSlice/itemCodeVerificationSlice";
import labourTypeChangeReducer from "../slices/HRSlice/labourTypeChangeSlice";
import hrAdvancePayReducer from "../slices/HRSlice/hrAdvancePayVerifySlice";
import labourAttendanceReportReducer from "../slices/HrReportSlice/labourAttendanceReportSlice";
import labourExitReducer from "../slices/HRSlice/labourExitSlice";
import pendingTrackingReducer from "../slices/dashboardSlice/pendingTrackingSlice";
import financialOverviewReducer from "../slices/dashboardSlice/financialOverviewSlice";
import hrDashboardReducer from "../slices/dashboardSlice/hrDashboardSlice";
import accountsDashboardReducer from "../slices/dashboardSlice/accountsDashboardSlice";
import snpDashboardReducer from "../slices/dashboardSlice/snpDashboardSlice";
import projectDashboardReducer from "../slices/dashboardSlice/projectDashboardSlice";
import ltaReportReducer from "../slices/HrReportSlice/ltaReportSlice";
import indentVerificationReducer from "../slices/purchaseSlice/indentVerificationSlice";
import indentCreationReducer from "../slices/purchaseSlice/indentCreationSlice";
import dailyIssueCreationReducer from "../slices/purchaseSlice/dailyIssueSlice";
import itemsTransferReducer from "../slices/purchaseSlice/itemsTransferSlice";
import lostOrDamagedItemsReducer from "../slices/purchaseSlice/lostOrDamagedItemsSlice";
import newStockReceivedReducer from "../slices/purchaseSlice/newStockReceivedSlice";
import newStockTransferReducer from "../slices/purchaseSlice/newStockTransferSlice";
import newStockIssueReducer from "../slices/purchaseSlice/newStockIssueSlice";
import indentAmendVerificationReducer from "../slices/purchaseSlice/indentAmendVerificationSlice";
import oldStockReceivedReducer from "../slices/purchaseSlice/oldStockReceivedSlice";
import scrapSaleCreationReducer from "../slices/purchaseSlice/scrapSaleSlice";
import storeClosingReducer from "../slices/purchaseSlice/storeClosingSlice";
import transferRecieptReducer from "../slices/purchaseSlice/transferRecieptSlice";
import transferRecieptMultiReducer from "../slices/purchaseSlice/transferRecieptMultiSlice";
import capitalStockIssueCreationReducer from "../slices/purchaseSlice/capitalStockIssueSlice";
import directStockUpdationCreationReducer from "../slices/purchaseSlice/directStockUpdationSlice";
import itemCodeCreationReducer from "../slices/purchaseSlice/itemCodeCreationSlice";
import oldStockIssueCreationReducer from "../slices/purchaseSlice/oldStockIssueSlice";
import verifyBankAccountsReducer from "../slices/accountsSlice/verifyBankAccountsSlice";
import verifyBankDepositReducer from "../slices/accountsSlice/verifyBankDepositSlice";
import verifyBankTransferReducer from "../slices/accountsSlice/verifyBankTransferSlice";
import verifyBankWithdrawalReducer from "../slices/accountsSlice/verifyBankWithdrawalSlice";
import verifyChequeReducer from "../slices/accountsSlice/verifyChequeSlice";
import verifyCloseMasterReducer from "../slices/accountsSlice/verifyCloseMasterSlice";
import verifyOpenFDReducer from "../slices/accountsSlice/verifyOpenFDSlice";
import verifyPartialFDReducer from "../slices/accountsSlice/verifyPartialFDSlice";
import verifyFDInterestReducer from "../slices/accountsSlice/verifyFDInterestSlice";
import verifyTermLoanReducer from "../slices/accountsSlice/verifyTermLoanSlice";
import verifyTLAgencyReducer from "../slices/accountsSlice/verifyTLAgencySlice";
import verifyTLPaymentReducer from "../slices/accountsSlice/verifyTLPaymentSlice";
import verifyUnsecuredLoanReducer from "../slices/accountsSlice/verifyUnsecuredLoanSlice";
import verifyUnsLoanInterestReducer from "../slices/accountsSlice/verifyUnsLoanInterestSlice";
import verifyShareCapitalReducer from "../slices/accountsSlice/verifyShareCapitalSlice";
import verifyShareCreationReducer from "../slices/accountsSlice/verifyShareCreationSlice";
import configVerificationReducer from "../slices/accountsSlice/configVerificationSlice";

const store = configureStore({

  reducer: {
    auth: authReducer,
    businessInfo: businesInfoReducer,
    workflow: workflowReducer,
    budget: budgetReducer,
    budgetreport: budgetReportReducer,
    accruedinterest: accruedInterestReducer,
    bankstatement: bankStatementReducer,
    clientporeport: clientPOReportReducer,
    transactionlog: transactionLogReducer,
    termloanreport: termLoanReportReducer,
    assetdepreciationreport:assetDepreciationReportReducer,
    assetsalesreport: assetsalesreportReducer,
    viewcurrentstock: viewCurrentStockReducer,
    supplierpostatus:supplierPOStatusReducer,
    scrapwalletreport:scrapWalletReportReducer,
    gstreport: gstReportReducer,
    supplierreport: supplierReportReducer,
    spporeport: spPOReportReducer,
    companyoverallstatus: companyOverallStatus,
    accountstatus: accountStatus,
    stockreconciliation: stockReconciliationReducer,
    stocktransferreport: stockTransferReportReducer,
    closingstockreport: closingStockReportReducer,
    viewindentsreport: viewIndentsReportReducer,
    dailyissueditemsreport: dailyIssuedItemsReportReducer,
    itemcodereport: itemCodeReportReducer,
    lostscrapreport: lostScrapReportReducer,
    lcbg: lcbgReducer,
    stocksummary: stockSummaryReducer,
    unsecuredloanreport: unsecuredLoanReportReducer,
    cmspaymentreport:cmsPaymentReportSlice,
    labourcmspaymentreport: labourCMSPaymentReportReducer,
    inboxnotifications: inboxNotificationReducer,
    approval: approvalReducer,
    vendorpayment: VendorPaymentReducer,
    supplierinvoice: SuppplierInvoiceReducer,
    supplierpo: SupplierPOReducer,
    purchaseHelper: purchaseHelperReducer,
    supplierPOCreation: supplierPOCreationReducer,
    supplierPOAmendCreation: supplierPOAmendCreationReducer,
    sppo: SppoReducer,
    costCenter: costCenterSlice,
    generalInvoice:generalInvoiceSlice,
    userrole: roleReducer,
    empRoleAssignment: empRoleAssignment,
    ccBudgetAmendment: ccBudgetAmendment,
    dcaBudgetAmendment: dcaBudgetAmendment,
    staffattendancereport: staffAttendanceReportReducer,
    employeeexitreport: employeeExitReportReducer,
    leavereport: leaveReportSlice,
    costCenterCreation: costCenterCreationReducer,
    clientPO: clientPOVerificationReducer,
    lostDamagedItems: lostDamagedItemsVerificationReducer,
    transferRecieptOthersVerification: transferRecieptOthersVerificationReducer,
    verifyNewStockReceived: verifyNewStockReceivedReducer,
    verifyVendor: verifyVendorReducer,
    dailyIssue: dailyIssuedItemsReducer,
    scrapSale: scrapSaleReducer,
    closeSPPO: closeSPPOReducer,
    sppoAmend: sppoAmend,
    sppoAmendCreation: sppoAmendCreation,
    sppoCloseCreation: sppoCloseCreation,
    sppoCreation: sppoCreation,
    supplierPOAmendVerification: supplierPOAmendVerificationReducer,
    monthlyattendance: monthlyattendance,
    staffdailyattendance: staffdailyattendance,
    labourobjectivesgoals: labourobjectivesgoals,
    staffobjectivesgoals: staffobjectivesgoals,
    employeectc: employeectc,
    labourctc: labourctc,
    labourpayrevision: labourpayrevision,
    staffpayrevision: staffpayrevision,
    employeeleave: employeeleave,
    dividendDeclaration: dividendDeclaration,
    dividendDistribution: dividendDistribution,
    dividendBankPayment: dividendBankPayment,
    bankDetails: bankDetails,
    chequeNumbers: chequeNumbers,
    pfesireport: pfesireport,
    salaryreport: salaryreport,
    staffreport: staffreport,
    staffctcreport: staffctcreport,
    staffcmspay: staffcmspay,
    hrStaffSepPayment: hrStaffSepPayment,
    labourSepPayment: labourSepPayment,
    staffcmspayverification: staffcmspayverification,
    staffpayroll:staffpayroll,
    staffpayrollverification: staffpayrollverification,
    salaryDeductionArrear: salaryDeductionArrear,
    salarydeductionarearverification: salaryDeductionArearVerification,
    staffJoin:  staffJoin,
    staffVerify: staffVerify,
    employeeTransfer: employeeTransfer,
    employeeExit:    employeeExitReducer,
    staffFullFinal:  staffFullFinalReducer,
    staffadvance:    staffAdvanceReducer,
    staffappraisal:  staffAppraisalReducer,
    staffCTCCreation:      staffCTCCreationReducer,
    staffAttendanceEntry:  staffAttendanceEntryReducer,
    staffReportingConfig:  staffReportingConfigReducer,
    employeePortal:        employeePortalReducer,
    cashvoucher:           cashVoucherReducer,
    vendorCashPayment:     vendorCashPaymentReducer,
    ccCashTransfer:        ccCashTransferReducer,
    ccClosing:             ccClosingReducer,
    clientInvoice:         clientInvoiceReducer,
    clientManfInvoice:     clientManfInvoiceReducer,
    clientScrapInvoice:    clientScrapInvoiceReducer,
    clientTradingInvoice:  clientTradingInvoiceReducer,
    genInvoiceCreation:    genInvoiceCreationReducer,
    miscInvoiceCreation:      miscInvoiceCreationReducer,
    miscInvoiceVerification:  miscInvoiceVerificationReducer,
    miscPayment:              miscPaymentReducer,
    miscPaymentVerification:  miscPaymentVerificationReducer,
    bankWithdrawal:        bankWithdrawalReducer,
    bankTransfer:          bankTransferReducer,
    genInvPayment:         genInvPaymentReducer,
    ccSepPayment:          ccSepPaymentReducer,
    clientPOCreation:      clientPOCreationReducer,
    clientPOAmend:         clientPOAmendReducer,
    workInProgress:        workInProgressReducer,
    sppoInvoice:           sppoInvoiceReducer,
    supplierPOInvoice:     supplierPOInvoiceReducer,
    loadWallet:            loadWalletReducer,
    lcbgCreation:          lcbgCreationReducer,
    sppoPayment:           sppoPaymentReducer,
    vendorCMSPayment:      vendorCMSPaymentReducer,
    vendorTDSPayment:      vendorTDSPaymentReducer,
    boeSettlement:         boeSettlementReducer,
    itemDepreciationConfig: itemDepreciationConfigReducer,
    hsnCreation: hsnCreationReducer,
    itemCodeUpdation: itemCodeUpdationReducer,
    indentAmend: indentAmendReducer,
    assetSale: assetSaleReducer,
    assetSaleReceipt: assetSaleReceiptReducer,
    ccStockClose: ccStockCloseReducer,
    vendorCreation: vendorCreationReducer,
    hrRules:               hrRulesReducer,
    basicBusinessInfo:     basicBusinessInfoReducer,
    consolidateCashflowReport: consolidateCashflowReportReducer,
    itDepreciationReport: itDepreciationReportReducer,
    projectFinancialStatusSummary: projectFinancialStatusSummaryReducer,
    stockStatusReport: stockStatusReportReducer,
    vendorInvoiceReport: vendorInvoiceReportReducer,
    vendorBalanceReport: vendorBalanceReportReducer,
    vendorOutStandingReport: vendorOutStandingReportReducer,
    clientOutstandingReport: clientOutstandingReportReducer,
    clientPaymentsReport: clientPaymentsReportReducer,
    clientTDSReport: clientTDSReportReducer,
    fdReport: fdReportReducer,
    fdPayments: fdPaymentsReducer,
    assignBudget: assignBudgetReducer,
    clientBadDebt:         clientBadDebtReducer,
    clientReceipt:         clientReceiptReducer,
    clientRecievableVerification: clientRecievableVerificationReducer,
    advancePaymentVerification:   advancePaymentVerificationReducer,
    retentionPaymentVerification: retentionPaymentVerificationReducer,
    holdPaymentVerification:      holdPaymentVerificationReducer,
    clientPOBudgetLimitConfig:    clientPOBudgetLimitConfigReducer,
    companyDepreciationConfig:    companyDepreciationConfigReducer,
    ccDayLimitConfig:             ccDayLimitConfigReducer,
    pageLevelConfig:              pageLevelConfigReducer,
    posUploadDocsLimitConfig:     posUploadDocsLimitConfigReducer,
    tdsConfigure:                 tdsConfigureReducer,
    approvalLimitSettings:        approvalLimitSettingsReducer,
    depreciationConfig:           depreciationConfigReducer,
    overheadPercentageConfig:     overheadPercentageConfigReducer,
    accruedInterestConfig:        accruedInterestConfigReducer,
    budgetViewAttachmentConfig:   budgetViewAttachmentConfigReducer,
    scrapSaleReceipt:             scrapSaleReceiptReducer,
    scrapSaleReceiptVerification: scrapSaleReceiptVerificationReducer,
    refund:                       refundReducer,
    refundVerification:           refundVerificationReducer,
    centralDayBook:               centralDayBookReducer,
    centralDayBookVerification:   centralDayBookVerificationReducer,
    journalVoucher:        journalVoucherReducer,
    creditDebitNote:       creditDebitNoteReducer,
    lcbgAmend:             lcbgAmendReducer,
    vendorPayableWriteoffCreation: vendorPayableWriteoffCreationReducer,
    unsecuredLoan:         unsecuredLoanReducer,
    termLoanCreation:      termLoanCreationReducer,
    termLoanPayment:       termLoanPaymentReducer,
    agencyCreation:        agencyCreationReducer,
    itCode:                itCodeReducer,
    dcaCreation:           dcaCreationReducer,
    subDca:                subDcaReducer,
    chequeBookCreation:    chequeBookCreationReducer,
    taxRegistration:       taxRegistrationReducer,
    bankAccount:           bankAccountReducer,
    client:                clientReducer,
    rejectionAlerts:       rejectionAlertReducer,
    labourConfig:          labourConfigReducer,
    labourPayroll:         labourPayrollReducer,
    labourCMSPayment:      labourCMSPaymentReducer,
    labourCMSVerification: labourCMSVerificationReducer,
    bulkWorkerReg:         bulkWorkerRegReducer,
    bulkWorkerVerify:      bulkWorkerVerifyReducer,
    generalPayment:        generalPaymentReducer,
    labourreport:          labourReportReducer,
    labourBankChange:      labourBankChangeReducer,
    empBankChange:         empBankChangeReducer,
    itemCodeVerification:  itemCodeVerificationReducer,
    labourTypeChange:      labourTypeChangeReducer,
    hrAdvancePay:          hrAdvancePayReducer,
    labourattendancereport: labourAttendanceReportReducer,
    labourExit:            labourExitReducer,
    pendingTracking:       pendingTrackingReducer,
    financialOverview:     financialOverviewReducer,
    hrDashboard:           hrDashboardReducer,
    accountsDashboard:     accountsDashboardReducer,
    snpDashboard:          snpDashboardReducer,
    projectDashboard:      projectDashboardReducer,
    ltaReport:             ltaReportReducer,
    indentVerification:    indentVerificationReducer,
    indentCreation:        indentCreationReducer,
    dailyIssueCreation:    dailyIssueCreationReducer,
    itemsTransfer:         itemsTransferReducer,
    lostOrDamagedItems:    lostOrDamagedItemsReducer,
    newStockReceived:      newStockReceivedReducer,
    newStockTransfer:      newStockTransferReducer,
    newStockIssue:         newStockIssueReducer,
    indentAmendVerification: indentAmendVerificationReducer,
    oldStockReceived:      oldStockReceivedReducer,
    scrapSaleCreation:     scrapSaleCreationReducer,
    storeClosing:          storeClosingReducer,
    transferReciept:       transferRecieptReducer,
    transferRecieptMulti:  transferRecieptMultiReducer,
    capitalStockIssueCreation: capitalStockIssueCreationReducer,
    directStockUpdationCreation: directStockUpdationCreationReducer,
    itemCodeCreation: itemCodeCreationReducer,
    oldStockIssueCreation: oldStockIssueCreationReducer,
    verifyBankAccounts:    verifyBankAccountsReducer,
    verifyBankDeposit:     verifyBankDepositReducer,
    verifyBankTransfer:    verifyBankTransferReducer,
    verifyBankWithdrawal:  verifyBankWithdrawalReducer,
    verifyCheque:          verifyChequeReducer,
    verifyCloseMaster:     verifyCloseMasterReducer,
    verifyOpenFD:          verifyOpenFDReducer,
    verifyPartialFD:       verifyPartialFDReducer,
    verifyFDInterest:      verifyFDInterestReducer,
    verifyTermLoan:        verifyTermLoanReducer,
    verifyTLAgency:        verifyTLAgencyReducer,
    verifyTLPayment:       verifyTLPaymentReducer,
    verifyUnsecuredLoan:   verifyUnsecuredLoanReducer,
    verifyUnsLoanInterest: verifyUnsLoanInterestReducer,
    verifyShareCapital:    verifyShareCapitalReducer,
    verifyShareCreation:   verifyShareCreationReducer,
    configVerification:    configVerificationReducer,

  },

  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(inboxRefreshMiddleware),

});


export default store